module.exports = __webpack_public_path__ + "media/slow.4fb519cc.mp4";